﻿import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {IClientModel} from "../../Model/Client/ClientModel";
import {OnClientAdd} from "../../Delegates/ClientDelegate";
import {NotificationHelper} from "../../Helper/NotificationHelper";

export class ClientCreate {
    /**
     * Crée le client et son compte de service (dont le login dérive de la
     * raison sociale : elle doit donc être connue dès la création).
     */
    public static Create = async (raisonSociale: string) => {
        return JsonFetchJson.Post<ResponseApi<IClientModel>>("/client/create", {RaisonSociale: raisonSociale})
            .then(response => {
                if (response.Errors.length)
                {
                    response.Errors.forEach(x => NotificationHelper.Instance.error(x.Message));
                    return;
                }
                
                OnClientAdd.Fire(response.Data);
                return response.Data;
            });
    }
}